/**
 * US Eastern desk clock. Always America/New_York via Intl (DST handled by the
 * tz database, never a fixed offset), whatever the browser's own time zone.
 */

export const US_EASTERN_TIME_ZONE = 'America/New_York'
export const US_EASTERN_LABEL = 'ET'

/** "07:30:05 PM" (or "07:30 PM" without seconds) in US Eastern time. */
export function formatEasternClock(date: Date, options: { seconds?: boolean } = {}): string {
  const withSeconds = options.seconds ?? true
  return new Intl.DateTimeFormat('en-US', {
    timeZone: US_EASTERN_TIME_ZONE,
    hour: '2-digit',
    minute: '2-digit',
    ...(withSeconds ? { second: '2-digit' as const } : {}),
  }).format(date)
}
